import httpClient from "./httpClient";

const BACKOFFICE_USERS_DETAILS = "/backoffice/user-details/";
const REMOVE_USER = "/backoffice/delete-user/";
const BACKOFFICE_EDIT_USER = "/backoffice/edit-user/";
const BACKOFFICE_SEARCH_USER = "/backoffice/wscsi-user-details/";

const BACKOFFICE_ENTITIES_DETAILS = "/backoffice/entities/";
const BACKOFFICE_CREATE_ENTITY = "/backoffice/entities/create";
const BACKOFFICE_EDIT_ENTITY = "/backoffice/entities/update/";
const REMOVE_ENTITY = "/backoffice/entities/inactivate/";
const ENTITY_GROUPS_DROPDOWN = "/dropdowns/active-entity-groups";
const ENTITY_COMPANY_DROPDOWN = "/dropdowns/active-entity-companies";
const GN_PRINCIPAL_DROPDOWN = "/dropdowns/business-managers/entity/";
const GNS_LIST = "/dropdowns/active-gns";
const INTALLATIONS_GSC_LIST = "/dropdowns/active-installation-db-gsc/"

const DOWNLOAD_USER_REPORT = "/backoffice/generate-excel-user-report";
const INACTIVATE_USER = "/backoffice/inactivate-user/";
const BUSINESSMANAGER_PRINCIPAL_LIST = "/dropdowns/businessmanager-principal";

const BACKOFFICE_COMPANIES_DETAILS = "/backoffice/company/";
const BACKOFFICE_CREATE_COMPANY = "/backoffice/company";
const INACTIVATE_ENTITY_COMPANY = "/backoffice/company/inactivate/";

const FINANCIALS_DROPDOWN = "/dropdowns/active-financials";
const COMPANY_GSC_LIST = "/dropdowns/companies-gsc/"

const BACKOFFICE_RATE_OF_SITE = "/backoffice/financial-rates-site";
const BACKOFFICE_DETELE_RATE_OF_SITE = "/backoffice/financial-rates-site/";
const BACKOFFICE_EDIT_RATE_OF_SITE = "/backoffice/financial-rates-site/";

const BACKOFFICE_FINANCIAL_DETAILS = "/backoffice/financial/";
const BACKOFFICE_SAVE_FINANCIAL = "/backoffice/financial/save";
const BACKOFFICE_GROUPS_LIST = "/backoffice/groups";
const BACKOFFICE_USERS_LIST = "/backoffice/users-simple-list";
const BACKOFFICE_CREATE_GROUP = "/backoffice/create-group";
const BACKOFFICE_EDIT_GROUP = "/backoffice/edit-group";
const BACKOFFICE_ADD_USER_GROUP = "/backoffice/add-users-group";
const BACKOFFICE_DELETE_USER_GROUP = "/backoffice/delete-group-user";

const BACKOFFICE_GET_FINANCIAL_DATA = "/backoffice/finance-data";
const BACKOFFICE_GET_TAEG_ALLOWED = "/backoffice/finance-data/taeg-allowed";
const BACKOFFICE_GET_ISCD = "/backoffice/finance-data/iscd";
const BACKOFFICE_GET_PRODUCTS = "/backoffice/finance-data/products";
const BACKOFFICE_ADD_TAEG = "/backoffice/finance-data/save/taeg-allowed";
const BACKOFFICE_ADD_ISCD = "/backoffice/finance-data/save/iscd";
const BACKOFFICE_SAVE_TRANSVERSAL = "/backoffice/finance-data/save/cross-sectional-data";
const BACKOFFICE_DELETE_TAEG = "/backoffice/finance-data/delete/taeg-allowed";
const BACKOFFICE_DELETE_ISCD = "/backoffice/finance-data/delete/iscd";
const BACKOFFICE_GET_TRANSVERSAL = "/backoffice/finance-data/cross-sectional-data";
const GET_ACTIVE_PRODUCTS_1 = "/dropdowns/financial/";
const GET_ACTIVE_PRODUCTS_2 = "/products";
const BACKOFFICE_DETELE_FINANCIAL_EXPENSE = "/backoffice/financial/";
const GET_CLIENT_TYPES = "/dropdowns/client-types";
const BACKOFFICE_INSURANCE_RATES = "/backoffice/financial/insurance-rates/";
const EXTRANET_INTALLATIONS_LIST = "/dropdowns/extranet-installations/";

const INSTANCES_DROPDOWN = "/dropdowns/active-instances";


function fetchBackofficeUsers(page, orderBy, search, pageSize, idInstance) {
    const BACKOFFICE_USERS = `/backoffice/users-list?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(BACKOFFICE_USERS + page + orderBy + search + '&descending=false');
}

function fetchUserDetailsByUserId(userId) {
    return httpClient.get(BACKOFFICE_USERS_DETAILS + userId);
}

function deleteUserByUserId(userId) {
    return httpClient.delete(REMOVE_USER + userId);
}

function editUser(userId, payload) {
    return httpClient.post(BACKOFFICE_EDIT_USER + userId, payload);
}

function searchUserGSCIByNIF(nif) {
    return httpClient.get(BACKOFFICE_SEARCH_USER + nif);
}

function fetchBackofficeEntities(page, orderBy, search, pageSize, idInstance) {
    const BACKOFFICE_ENTITIES = `/backoffice/entities?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(BACKOFFICE_ENTITIES + page + orderBy + search + '&descending=false');
}

function fetchEntityDetailsByEntityId(entityId) {
    return httpClient.get(BACKOFFICE_ENTITIES_DETAILS + entityId);
}

function registerNewEntity(payload) {
    return httpClient.post(BACKOFFICE_CREATE_ENTITY, payload);
}

function editEntity(entityId, payload) {
    return httpClient.put(BACKOFFICE_EDIT_ENTITY + entityId, payload);
}

function deleteEntityByEntityId(entityId) {
    return httpClient.put(REMOVE_ENTITY + entityId);
}

function getEntityGroupsDropdown(idInstance) {
    return httpClient.get(`${ENTITY_GROUPS_DROPDOWN}?idInstance=${idInstance}`);
}

function getEntityCompanyDropdown(idInstance) {
    return httpClient.get(`${ENTITY_COMPANY_DROPDOWN}?idInstance=${idInstance}`);
}

function getGNPrincipalDropdown(entityId, idInstance) {
    return httpClient.get(`${GN_PRINCIPAL_DROPDOWN + entityId}?idInstance=${idInstance}`);
}

function fetchGnsList(idInstance) {
    return httpClient.get(`${GNS_LIST}?idInstance=${idInstance}`);
}

function getDBGSCInstalationsDropdown(idCompanyGSC) {
    return httpClient.get(INTALLATIONS_GSC_LIST + idCompanyGSC);
}

function getSearchByPostalCode({ postalCode, formNationality }) {
    const proposalNationality = formNationality === "ES" ? "es" : "pt";
    return httpClient.get(`/dropdowns/search-postal-area?country=${proposalNationality}&postalCode=${postalCode}`);
}

function downloadUsersReport(search, idInstance) {
    return httpClient.get(`${DOWNLOAD_USER_REPORT}?idInstance=${idInstance}&${search}`, {
        headers: {
            Accept: "*/*",
        },
        responseType: "blob",
    });
}

function inactivateUserByUserId(userId) {
    return httpClient.put(INACTIVATE_USER + userId);
}

function fetchBackofficeGroups(page, orderBy, pageSize, idInstance) {
    const BACKOFFICE_GET_ALL_GROUPS = `/backoffice/users-groups/?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(BACKOFFICE_GET_ALL_GROUPS + page + orderBy + '&descending=true');
}

function fetchGroupsList(idInstance) {
    return httpClient.get(`${BACKOFFICE_GROUPS_LIST}?idInstance=${idInstance}`);
}

function fetchUsersList(idInstance) {
    return httpClient.get(`${BACKOFFICE_USERS_LIST}?idInstance=${idInstance}`);
}

function createGroup(groupDataPayload) {
    return httpClient.post(BACKOFFICE_CREATE_GROUP, groupDataPayload);
}

function editGroup(groupDataPayload, groupId) {
    return httpClient.put(BACKOFFICE_EDIT_GROUP + `?groupId=${groupId}`, groupDataPayload);
}

function addUserToGroup(payload) {
    return httpClient.post(BACKOFFICE_ADD_USER_GROUP, payload);
}

function deleteGroupUser(userId) {
    return httpClient.delete(BACKOFFICE_DELETE_USER_GROUP + `?userId=${userId}`);
}

function fetchBackofficeCompanies(page, orderBy, search, pageSize, idInstance) {
    const BACKOFFICE_COMPANIES = `/backoffice/company?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(BACKOFFICE_COMPANIES + page + orderBy + search + '&descending=false');
}

function fetchCompanyDetailsById(companyId) {
    return httpClient.get(BACKOFFICE_COMPANIES_DETAILS + companyId);
}

function registerNewCompany(payload) {
    return httpClient.post(BACKOFFICE_CREATE_COMPANY, payload);
}

function editCompany(companyId, payload) {
    return httpClient.post(BACKOFFICE_CREATE_COMPANY, payload);
}

function uploadCompanyDoc({ companyId, base64File, filename, brand }) {
    const formData = new FormData();
    formData.append('file', base64File);
    const filenamePathToAdd = filename ? `?filename=${filename}` : "";

    return httpClient.put(`/backoffice/company/${companyId}/upload-file/brand/${brand}` + filenamePathToAdd, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
}

function downloadCompanyDocument({ idEntityCompanyDocument, idEntityCompany, documentName }) {
    return httpClient.get(`/backoffice/company/${idEntityCompany}/document/${idEntityCompanyDocument}?${documentName}`, {
        headers: {
            Accept: "*/*",
        },
        responseType: "blob"
    });
}

function deleteCompanyDocument({ idEntityCompanyDocument, idEntityCompany }) {
    return httpClient.delete(`/backoffice/company/${idEntityCompany}/document/${idEntityCompanyDocument}`);
}

function fetchBusinessManagerPincipalList(idInstance) {
    return httpClient.get(`${BUSINESSMANAGER_PRINCIPAL_LIST}?idInstance=${idInstance}`);
}

function getFinancialList(idInstance) {
    return httpClient.get(`${FINANCIALS_DROPDOWN}?idInstance=${idInstance}&type=ALL`);
}

function getCompanyGSCList(idInstance, country) {
    return httpClient.get(`${COMPANY_GSC_LIST}?idInstance=${idInstance}&country=${country}`);
}

function inactivateEntityCompanyById(idEntityCompany) {
    return httpClient.put(INACTIVATE_ENTITY_COMPANY + idEntityCompany);
}

//Financial Rates Site
function fetchBackofficeFinancialRatesSite(page, orderBy, search, pageSize, idInstance) {
    const BACKOFFICE_FINANCIAL_RATES_SITE = `/backoffice/financial-rates-site?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(BACKOFFICE_FINANCIAL_RATES_SITE + page + orderBy + search + '&descending=false');
}

function editFinancialRateSite(rateSiteId, payload) {
    console.log(rateSiteId)
    return httpClient.put(BACKOFFICE_EDIT_RATE_OF_SITE, payload);
}

function registerNewRateSite(payload) {
    return httpClient.post(BACKOFFICE_RATE_OF_SITE, payload);
}

function deleteRateSiteById(idFinancialRatesSite, idFinancial) {
    return httpClient.delete(BACKOFFICE_DETELE_RATE_OF_SITE + `${idFinancialRatesSite}/financial/${idFinancial}`);
}

//Financials 
function fetchBackofficeFinancials(page, orderBy, search, pageSize, idInstance) {
    const BACKOFFICE_FINANCIALS = `/backoffice/financials-list?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(BACKOFFICE_FINANCIALS + page + orderBy + search + '&descending=false');
}

function fetchFinancialDetailsById(financialId, idInstance) {
    return httpClient.get(BACKOFFICE_FINANCIAL_DETAILS + financialId + `?idInstance=${idInstance}`);
}

function saveFinancial(dataType, payload) {
    return httpClient.put(BACKOFFICE_SAVE_FINANCIAL+`?data=${dataType}`, payload);
}

function getFinancialData() {
    return httpClient.get(BACKOFFICE_GET_FINANCIAL_DATA);
}

function getTAEGAllowed(idInstance) {
    return httpClient.get(`${BACKOFFICE_GET_TAEG_ALLOWED}?idInstance=${idInstance}`);
}

function getISCD(queryString) {
    return httpClient.get(BACKOFFICE_GET_ISCD + queryString);
}

function getProducts(idInstance) {
    return httpClient.get(`${BACKOFFICE_GET_PRODUCTS}?idInstance=${idInstance}`);
}

function getTransversal() {
    return httpClient.get(BACKOFFICE_GET_TRANSVERSAL);
}

function addTaeg(payload) {
    return httpClient.post(BACKOFFICE_ADD_TAEG, payload);
}

function addIscd(payload) {
    return httpClient.post(BACKOFFICE_ADD_ISCD, payload);
}

function saveTransversal(payload, origin = 'transversal-data') {
    return httpClient.put(BACKOFFICE_SAVE_TRANSVERSAL +`?origin=${origin}`, payload);
}
function deleteTaeg(payload) {
    return httpClient.delete(BACKOFFICE_DELETE_TAEG, { data: payload });
}

function deleteIscd(payload) {
    return httpClient.put(BACKOFFICE_DELETE_ISCD, payload);
}

function getProductsByFinancialId(id, idInstance=null) {
    return httpClient.get(GET_ACTIVE_PRODUCTS_1 + id + GET_ACTIVE_PRODUCTS_2 + `?idInstance=${idInstance}`);
}

function deleteFinancialExpense(idFinancial, queryParams) {
    return httpClient.delete(BACKOFFICE_DETELE_FINANCIAL_EXPENSE + `${idFinancial}/expense` + queryParams);
}

function addFinancialExpense(idFinancial, payload) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/add-expense`, payload);
}

function addNewFinancialRate(idFinancial, payload) {
    return httpClient.post(`/backoffice/financial/${idFinancial}/add-rate`, payload);
}

function deleteFinancialIndexRate(idFinancial, queryParams) {
    return httpClient.delete(BACKOFFICE_DETELE_FINANCIAL_EXPENSE + `${idFinancial}/euribor` + queryParams);
}

function addFinancialIndexRate(idFinancial, payload) {
    return httpClient.post(`/backoffice/financial/${idFinancial}/add-euribor`, payload);
}

function deleteFinancialInsuranceRate(queryParams) {
    return httpClient.delete(BACKOFFICE_INSURANCE_RATES + `delete` + queryParams);
}

function addFinancialInsuranceRate(payload) {
    return httpClient.put(BACKOFFICE_INSURANCE_RATES + `add`, payload);
}

function getInsuranceData({ idFinancial, idInstance, idEntityCompany, idInsurance, dtStart }) {
    return httpClient.get(`/backoffice/financial/${idFinancial}/entity-company/${idEntityCompany}/insurance/${idInsurance}/coeficients?dtStart=${dtStart}&idInstance=${idInstance}`);
}

function addInsuranceData({ idFinancial, idInsurance, payload}) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/insurance/${idInsurance}/coeficients?operation=add`, payload);
}

function editInsuranceData({ idFinancial, idEntityCompany, idInsurance, payload, dtStart }) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/entity-company/${idEntityCompany}/insurance/${idInsurance}/coeficients?dtStart=${dtStart}&operation=edit`, payload);
}

function deleteInsuranceData({ idFinancial, idInsurance, payload }) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/insurance/${idInsurance}/coeficients?operation=delete`, payload);
}

function updateInsurancesAvailableByFinancial(payload) {
    return httpClient.post(`/backoffice/financial/associate-insurance`, payload);
}
  
function saveFinancialRatesValue(idFinancial, payload) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/rate-value`, payload);
}

function deleteFinancialRate(idFinancial, idFinancialRate, idInstance) {
    return httpClient.delete(`/backoffice/financial/${idFinancial}/rate/${idFinancialRate}?idInstance=${idInstance}`);
}

function fetchClientTypes(status) {
    const queryStatus = status ? `?status=${status}` : '';
    return httpClient.get(GET_CLIENT_TYPES + queryStatus);
}

//Insurances

function fetchBackofficeInsurances(page, orderBy, search, pageSize, idInstance) {
    const BACKOFFICE_INSURANCES = `/backoffice/insurances-list?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(BACKOFFICE_INSURANCES + page + orderBy + search + '&descending=false');
}

function alterBackofficeInsurances(operation, payload){
    const BACKOFFICE_INSURANCES_ALTER = `/backoffice/insurance?operation=${operation}`;
    return httpClient.put(BACKOFFICE_INSURANCES_ALTER, payload);
}

function saveFinancialRatesSalesman(idFinancial, operation, payload) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/rates-salesman?q=${operation}`, payload);
}

function financialTinsOperation(idFinancial, operation, payload) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/tins?q=${operation}`, payload);
}

function getTinsDropdownBy(idFinancial, idInstance) {
    return httpClient.get(`/dropdowns/financial/${idFinancial}/tins?idInstance=${idInstance}`);
}

function createResidualValue(idFinancial, payload) {
    return httpClient.post(`/backoffice/financial/${idFinancial}/create-residual-value`, payload);
}

function deleteResidualValue({idFinancial, idGroup, brand, idProduct, idClient, idInstance, idFinancialInstance}) {
    return httpClient.delete(`/backoffice/financial/${idFinancial}/residual-value?idGroup=${idGroup}&brand=${brand}&idProduct=${idProduct}&idClient=${idClient}&idInstance=${idInstance}&idFinancialInstance=${idFinancialInstance}`);
}

function createRateAllowed(idFinancial, payload) {
    return httpClient.post(`/backoffice/financial/${idFinancial}/create-reward-rate-allowed`, payload);
}

function deleteRateAllowed({idFinancial, idInstance, idClienttype}) {
    return httpClient.delete(`/backoffice/financial/${idFinancial}/reward-rate-allowed/?idClienttype=${idClienttype}&idInstance=${idInstance}`);
}

function updateProductsAvailableByFinancial(payload) {
    return httpClient.post(`/backoffice/finance-data/save/products`, payload);
}

function createEntityApiCredentials(payload) {
    return httpClient.post(`/backoffice/entity-api-credentials`, payload);
}

function deleteEntityApiCredentials(idFinancial, idInstance, idEntity, idUserParam) {
    return httpClient.delete(`/backoffice/financial/${idFinancial}/entity-api-credentials/?idEntity=${idEntity}&idUserParam=${idUserParam}&idInstance=${idInstance}`);
}

function updateEntityApiCredentials(payload) {
    return httpClient.put(`/backoffice/entity-api-credentials`, payload);
}

function getFinacialDisclaimer(idFinancial, idInstance, idDisclaimer) {
    return httpClient.get(`/backoffice/financial/${idFinancial}/disclaimer-phrase/${idDisclaimer}?idInstance=${idInstance}`);
}

function financialDisclaimerOperation(idFinancial, operation, payload) {
    return httpClient.put(`/backoffice/financial/${idFinancial}/disclaimer-phrase?q=${operation}`, payload);
}

function getExtranetInstallations(country, idEntityGroup, idInstance) {
    return httpClient.get(`${EXTRANET_INTALLATIONS_LIST}${country}?idEntityGroup=${idEntityGroup}&idInstance=${idInstance}`);
}

function getInstances() {
    return httpClient.get(INSTANCES_DROPDOWN);
}

export {
    fetchBackofficeUsers, fetchUserDetailsByUserId, deleteUserByUserId, editUser,
    searchUserGSCIByNIF, fetchBackofficeEntities, fetchEntityDetailsByEntityId, editEntity, deleteEntityByEntityId, getEntityGroupsDropdown,
    fetchGroupsList, fetchUsersList, createGroup, addUserToGroup, deleteGroupUser, editGroup,
    fetchGnsList, downloadUsersReport, inactivateUserByUserId, getEntityCompanyDropdown, getGNPrincipalDropdown, getDBGSCInstalationsDropdown, registerNewEntity,
    getSearchByPostalCode, fetchBackofficeCompanies, fetchCompanyDetailsById, registerNewCompany, editCompany, fetchBusinessManagerPincipalList,
    getFinancialList, getCompanyGSCList, inactivateEntityCompanyById, fetchBackofficeFinancialRatesSite, registerNewRateSite, deleteRateSiteById,
    editFinancialRateSite, getFinancialData, getProducts, addTaeg, deleteTaeg, fetchBackofficeGroups, getTAEGAllowed, getISCD, addIscd, deleteIscd,
    getTransversal, saveTransversal, fetchBackofficeFinancials, fetchFinancialDetailsById, saveFinancial, getProductsByFinancialId,
    deleteFinancialExpense, addFinancialExpense, getInsuranceData, addInsuranceData, editInsuranceData, deleteInsuranceData, addNewFinancialRate, saveFinancialRatesValue, deleteFinancialRate,
    fetchClientTypes, createResidualValue, deleteResidualValue, createRateAllowed, deleteRateAllowed, updateProductsAvailableByFinancial,
    addFinancialIndexRate, deleteFinancialIndexRate,
    fetchBackofficeInsurances, alterBackofficeInsurances, saveFinancialRatesSalesman, financialTinsOperation,
    getTinsDropdownBy, updateInsurancesAvailableByFinancial,
    createEntityApiCredentials, deleteEntityApiCredentials, updateEntityApiCredentials, deleteFinancialInsuranceRate, addFinancialInsuranceRate, 
    uploadCompanyDoc, downloadCompanyDocument, getFinacialDisclaimer,
    financialDisclaimerOperation, deleteCompanyDocument,
    getExtranetInstallations,
    getInstances,
};
